// Strict host match — substring checks like `includes("localhost")` are exploitable
// (`evil-localhost.com` would pass), so a custom domain can never masquerade as a trusted host.
export function isLocalhost(host) {
    return host === "localhost" || host === "127.0.0.1" || host === "[::1]" || host.endsWith(".localhost");
}
// Only a recognized Tickaroo host may originate an authenticated platform-API request. Never derive
// the origin from an arbitrary (possibly customer-owned) custom-domain hostname — otherwise the
// browser could send the Descope bearer token to a host we don't control. Returns the Tickaroo public
// domain, or null on a custom-domain host. Localhost signs in against the staging Descope project.
export function tickarooPlatformDomain() {
    const host = window.location.hostname;
    if (isLocalhost(host))
        return "tickaroo-staging.com";
    if (host === "tickaroo.com" || host.endsWith(".tickaroo.com"))
        return "tickaroo.com";
    if (host === "tickaroo-staging.com" || host.endsWith(".tickaroo-staging.com"))
        return "tickaroo-staging.com";
    return null;
}
//# sourceMappingURL=tickarooPlatformDomain.js.map